import {
    put, takeLatest, call
} from 'redux-saga/effects';
import { authenticatedAxios, axios } from '../client';
import {
    SEND_REMINDER,
    sendReminderSuccess,
    sendReminderFailure,
    FETCH_LINK,
    fetchLinkSuccess,
    fetchLinkFailure,
    LINK_REDEMPTION_ACCOUNT
} from "../actions";
import {linkRedemptionAccount} from "../actions/index";
import {
    GET_GIFT, getGift, GET_GIFT_FROM_HASH, getGiftFromHash, connectCard, CONNECT_CARD,
    DISCONNECT_CARD, disconnectCard, GET_EXCHANGE_OPTIONS, getExchangeOptions,
    CONVERT_TO_E_GIFT, convertToEGift, GET_E_GIFT, getEGift, UPDATE_GIFT_BALANCE, updateGiftBalance,
    DELETE_REDEMPTION_ACCOUNT, deleteRedemptionAccount,
    CREATE_GIFT_REDEMPTION_ACCOUNT_LINK, createGiftRedemptionAccountLink, REORDER_GIFT, reorderGift, getReceivedGifts,
    GET_RECEIVED_GIFTS, GET_SENT_GIFTS, GET_ORDER, getOrder, EXCHANGE_GIFT_MERCHANT,
    exchangeGiftMerchant,
    EXCHANGE_GIFT_VIRTUAL_VISA, exchangeGiftVirtualVisa,
    EXCHANGE_GIFT_PHYSICAL_VISA, exchangeGiftPhysicalVisa,
    POLL_E_GIFT, pollEGift, SEND_THANKYA, sendThankYa, getSentGifts, CHANGE_GIFT_RECIPIENT, changeGiftRecipient,
    CHANGE_GIFT_DATE_SEND, changeGiftDateSend,
    SELF_GIFT_CHANGE_GIFT_RECIPIENT, selfGiftChangeGiftRecipient, REFUND_GIFT, refundGift,
    CREATE_PAYMENT_METHOD_WITH_REDEMPTION_ACCOUNT, createPaymentMethodWithRedemptionAccount, GIFTYA_SELECT_SELECT_MERCHANT, giftyaSelectSelectMerchant
} from "../actions/gift";


function* handleGiftYaSelectSelectMerchant({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const params = new URLSearchParams();
        params.append('merchantId', payload.merchantId);
        yield call(authenticatedAxios.post, `${window.react_giftya_base_url}/secure/u/${payload.giftHash}/select-merchant`, params);
    } catch (error) {
        yield put(giftyaSelectSelectMerchant(error, {}, true));
    }

    yield put(giftyaSelectSelectMerchant({
        giftyaSelectSelectMerchantSuccess: true,
        giftyaSelectGiftHash: payload.giftHash
    }, {'sent': true}));
}
export function* watchGiftYaSelectSelectMerchant() {
    yield takeLatest(GIFTYA_SELECT_SELECT_MERCHANT, handleGiftYaSelectSelectMerchant);
}



function* handleRefundGift({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        yield call(authenticatedAxios.post, `${window.api_url}/gifts/${payload.giftId}/refunds`);
    } catch (error) {
        yield put(refundGift(error, {}, true));
    }

    yield put(refundGift({
        refundGiftSuccess: true
    }, {'sent': true}));
}
export function* watchRefundGift() {
    yield takeLatest(REFUND_GIFT, handleRefundGift);
}




function* handleSelfGiftChangeGiftRecipient({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        yield call(authenticatedAxios.post,
            `${window.api_url}/site-secure/gift/${payload.giftId}/change-recipient`,
            { 'new_recipient': payload.recipient }
        );

    } catch (error) {
        yield put(selfGiftChangeGiftRecipient(error, {}, true));
    }

    yield put(selfGiftChangeGiftRecipient({
        selfGiftChangeGiftRecipientSuccess: true
    }, {'sent': true}));
}
export function* watchSelfGiftChangeGiftRecipient() {
    yield takeLatest(SELF_GIFT_CHANGE_GIFT_RECIPIENT, handleSelfGiftChangeGiftRecipient);
}

function* handleChangeGiftRecipient({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    let recipient = payload.recipient;

    if (payload.isPhoneNumber) {

        const messages = {
            phoneNumber: 'We are unable to send a text to this number. Landline and international numbers are not supported. Please enter a valid phone number or contact customer support.'
        };


        // Twilio check starts here
        let phoneNumber = payload.recipient.replace(/[^0-9]/g, '');
        const message = messages.phoneNumber;

        if (phoneNumber.charAt(0) !== '1') {
            phoneNumber = '1' + phoneNumber;
        }

        recipient = phoneNumber;

        if (phoneNumber.length !== 11) {
            yield put(changeGiftRecipient({message}, {}, true));
        }
        const sessionStorageKeyPrefix = 'giftya_sms_deliverability_status_';

        // Check session storage value if supported.
        let smsDeliverabilityStatus = typeof (Storage) !== 'undefined' ? sessionStorage.getItem(sessionStorageKeyPrefix + phoneNumber) : null;
        if (smsDeliverabilityStatus !== null && parseInt(smsDeliverabilityStatus) !== 1) {
            yield put(changeGiftRecipient({message}, {}, true));
        }

        try {
            const response = yield call(axios.get, `${window.api_url}/site/twilio/deliverability?phone_number=${phoneNumber}`);
            sessionStorage.setItem(sessionStorageKeyPrefix + phoneNumber, response.data.can_send_sms);

            if (parseInt(response.data.can_send_sms) !== 1) {
                yield put(changeGiftRecipient({message}, {}, true));
            }

        } catch (error) {
            sessionStorage.setItem(sessionStorageKeyPrefix + phoneNumber, smsDeliverabilityStatus);
        }
    }   // Twilio validation ends here

    try {
        yield call(authenticatedAxios.post,
            `${window.api_url}/site-secure/gift/${payload.giftId}/change-recipient`,
            { 'new_recipient': recipient }
        );
    } catch (error) {
        yield put(changeGiftRecipient(
            {
                message: null,
                error: error
            }
            , {}, true));
    }

    yield put(changeGiftRecipient({
        changeGiftRecipientSuccess: true
    }, {'sent': true}));
}
export function* watchChangeGiftRecipient() {
    yield takeLatest(CHANGE_GIFT_RECIPIENT, handleChangeGiftRecipient);
}

function* handleChangeGiftDateSend({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        yield call(authenticatedAxios.post,
            `${window.api_url}/site-secure/gift/${payload.giftId}/change-date-send`,
            { 'date_send': payload.dateSend }
        );

    } catch (error) {
        yield put(changeGiftDateSend(error, {}, true));
    }

    yield put(changeGiftDateSend({
        changeGiftDateSendSuccess: true
    }, {'sent': true}));
}
export function* watchChangeGiftDateSend() {
    yield takeLatest(CHANGE_GIFT_DATE_SEND, handleChangeGiftDateSend);
}

function* handleSendReminder(action) {
    try {
        yield call(authenticatedAxios.post,
            `${window.api_url}/site-secure/gift/${action.data.giftId}/create-recipient-reminder-notification`
        );
        yield put(sendReminderSuccess());
    } catch (e) {
        yield put(sendReminderFailure(e.response));
    }
}
export function* watchSendReminder() {
    yield takeLatest(SEND_REMINDER, handleSendReminder);
}


function* handleFetchLink(action) {
    try {
        const response = yield call(authenticatedAxios.get,
            `${window.api_url}/site-secure/gift/${action.data.giftId}/redemption-link`
        );
        yield put(fetchLinkSuccess(response));
    } catch (e) {
        yield put(fetchLinkFailure(e.response));
    }
}
export function* watchFetchLink() {
    yield takeLatest(FETCH_LINK, handleFetchLink);
}


function* handleLinkRedemptionAccount({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    let data;
    try {
        const response = yield call(authenticatedAxios.post,
            `${window.api_url}/gift-redemption-accounts`,
            {
                redemption_account: payload.redemptionAccountId,
                gift: payload.giftId
            }
        );
        data = response.data;
        data.giftId = payload.giftId;
    } catch (error) {
        yield put(linkRedemptionAccount(error, {}, true));
    }

    yield put(linkRedemptionAccount(data, {'sent': true}));
}
export function* watchLinkRedemptionAccount() {
    yield takeLatest(LINK_REDEMPTION_ACCOUNT, handleLinkRedemptionAccount);
}


function* handleGetGift({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    let data;
    try {
        const response = yield call(authenticatedAxios.get,
            `${window.api_url}/gifts/${payload.giftId}`
        );
        data = response.data;
    } catch (error) {
        yield put(getGift(error, {}, true));
    }

    yield put(getGift(data, {'sent': true}));
}
export function* watchGetGift() {
    yield takeLatest(GET_GIFT, handleGetGift);
}


function* handleGetGiftFromHash({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const response = yield call(axios.get,
            `${window.api_url}/site/gift-preview-by-link-hash/${payload.giftHash}`
        );

        yield put(getGiftFromHash({gift: response.data}, {'sent': true}));
    } catch (error) {
        yield put(getGiftFromHash(error, {}, true));
    }
}
export function* watchGetGiftFromHash() {
    yield takeLatest(GET_GIFT_FROM_HASH, handleGetGiftFromHash);
}


function* handleGetEGift({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    let data;
    try {
        const response = yield call(authenticatedAxios.get,
            `${window.api_url}/egifts/${payload.eGiftId}`
        );

        data = {
            gift: response.data
        };

    } catch (error) {
        yield put(getEGift(error, {}, true));
    }

    yield put(getEGift(data, {'sent': true}));
}
export function* watchGetEGift() {
    yield takeLatest(GET_E_GIFT, handleGetEGift);
}


function* handlePollEGift({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    let data;
    try {
        const response = yield call(authenticatedAxios.get,
            `${window.api_url}/egifts/${payload.eGiftId}`
        );

        data = {
            gift: response.data,
            remainingCount: payload.remainingCount - 1
        };

    } catch (error) {
        yield put(pollEGift(error, {}, true));
    }

    yield put(pollEGift(data, {'sent': true}));
}
export function* watchPollEGift() {
    yield takeLatest(POLL_E_GIFT, handlePollEGift);
}


function* handleConnectCard({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    try {
        if ((!window.userFirstName || !window.userLastName) && payload.cardFirstName && payload.cardLastName) {
            try {
                yield call(authenticatedAxios.post,
                    `${window.api_url}/site-secure/account/${window.accountId}/update-profile`,
                    {
                        'first_name': payload.cardFirstName,
                        'last_name': payload.cardLastName,
                        'agreed_to_terms': true
                    }
                );
            } catch (e) {
                console.log('Could not update profile.');
            }
        }
        let createRedemptionAccountResponse;
        try {
            createRedemptionAccountResponse = yield call(authenticatedAxios.post,
                `${window.api_url}/accounts/${window.accountId}/redemption-methods`,
                payload.redemptionAccountDetails
            );
        } catch (error) {
            yield put(connectCard(error, {}, true));
        }
        // if no error and redemption account created, then link
        try {
            yield call(authenticatedAxios.post,
                `${window.api_url}/gift-redemption-accounts`,
                {
                    redemption_account: createRedemptionAccountResponse.data.id,
                    gift: payload.giftId
                }
            );
        } catch (e) {
            yield put(connectCard(error, {}, true));
        }
    } catch (error) {
        yield put(connectCard(error, {}, true));
    }
    yield put(connectCard({
        cardIsConnected: true
    }, {'sent': true}));

}
export function* watchConnectCard() {
    yield takeLatest(CONNECT_CARD, handleConnectCard);
}


function* handleDisconnectCard({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    let data;
    try {
        const params = new URLSearchParams();
        params.append('redemption_account', payload.redemptionAccountId);
        params.append('gift', payload.giftId);

        const response = yield call(authenticatedAxios.post,
            `${window.api_url}/site-secure/gift/delete/gift-redemption-accounts`,
            params
        );
        data = {
            gift: response.data,
            cardIsDisconnected: true
        };

    } catch (error) {
        yield put(disconnectCard(error, {}, true));
    }
    yield put(disconnectCard(data, {'sent': true}));
}
export function* watchDisconnectCard() {
    yield takeLatest(DISCONNECT_CARD, handleDisconnectCard);
}


function* handleDeleteRedemptionAccount({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    let data;
    try {

        const params = new URLSearchParams();
        params.append('redemptionAccountId', payload.redemptionAccountId);
        params.append('giftId', payload.giftId);

        yield call(authenticatedAxios.post,
            `${window.react_giftya_base_url}/secure/redeem/delete-gift-redemption-account`,
            params
        );
        data = {
            redemptionAccountIsDeleted: true
        };
    } catch (error) {
        yield put(deleteRedemptionAccount(error, {}, true));
    }
    yield put(deleteRedemptionAccount(data, {'sent': true}));
}
export function* watchDeleteRedemptionAccount() {
    yield takeLatest(DELETE_REDEMPTION_ACCOUNT, handleDeleteRedemptionAccount);
}


function* handleGetExchangeOptions({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    let response;
    try {
        response = yield call(authenticatedAxios.get,
            `${window.api_url}/gifts/${payload.visibleId}/exchange-options`
        );
    } catch (error) {
        yield put(getExchangeOptions(error, {}, true));
    }

    yield put(getExchangeOptions({
        exchangeOptions: response.data
    }, {'sent': true}));
}
export function* watchGetExchangeOptions() {
    yield takeLatest(GET_EXCHANGE_OPTIONS, handleGetExchangeOptions);
}


function* handleConvertToEGift({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    let data;
    try {
        data = yield call(authenticatedAxios.post,
            payload.link,
        );
    } catch (error) {
        yield put(convertToEGift(error, {}, true));
    }
    yield put(convertToEGift(data, {'sent': true}));
}
export function* watchConvertToEGift() {
    yield takeLatest(CONVERT_TO_E_GIFT, handleConvertToEGift);
}


function* handleUpdateGiftBalance({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    let data;
    try {
        data = yield call(authenticatedAxios.get,
            `/egifts/${payload.giftId}/refresh-balance`,
        );
    } catch (error) {
        yield put(updateGiftBalance(error, {}, true));
    }
    yield put(updateGiftBalance(data, {'sent': true}));
}
export function* watchUpdateGiftBalance() {
    yield takeLatest(UPDATE_GIFT_BALANCE, handleUpdateGiftBalance);
}


function* handleCreateGiftRedemptionAccountLink({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    let response;
    try {
        const params = new URLSearchParams();
        params.append('account_id', payload.account_id);
        params.append('account_number', payload.account_number);
        params.append('public_token', payload.public_token);
        params.append('institution_id', payload.institution_id);
        params.append('institution_name', payload.institution_name);
        params.append('gift_id', payload.gift_id);
        params.append('gift_id_numeric', payload.gift_id_numeric);
        if (payload.redemption_account_id) {
            params.append('redemption_account_id', payload.redemption_account_id);
        }


        response = yield call(authenticatedAxios.post,
            `${window.react_giftya_base_url}/secure/redeem/create-gift-redemption-account-link`,
            params
        );

    } catch (error) {
        yield put(createGiftRedemptionAccountLink(error, {}, true));
    }
    yield put(createGiftRedemptionAccountLink(response.data, {'sent': true}));
}
export function* watchCreateGiftRedemptionAccountLink() {
    yield takeLatest(CREATE_GIFT_REDEMPTION_ACCOUNT_LINK, handleCreateGiftRedemptionAccountLink);
}


function* handleReorderGift({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    let response;
    try {
        const params = new URLSearchParams();
        params.append('giftId', payload.giftId);

        response = yield call(authenticatedAxios.post,
            `${window.react_giftya_base_url}/cart/resend-giftya`,
            params
        );
    } catch (error) {
        yield put(reorderGift(error, {}, true));
    }
    yield put(reorderGift(response.data, {'sent': true}));
}
export function* watchReorderGift() {
    yield takeLatest(REORDER_GIFT, handleReorderGift);
}


function* handleGetReceivedGifts({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    let response;
    try {
        response = yield call(authenticatedAxios.get,
            `${window.api_url}/site-secure/account/${payload.accountId}/gifts/received/minimum`
        );
    } catch (error) {
        yield put(getReceivedGifts(error, {}, true));
    }
    yield put(getReceivedGifts(response.data, {'sent': true}));
}
export function* watchGetReceivedGifts() {
    yield takeLatest(GET_RECEIVED_GIFTS, handleGetReceivedGifts);
}


function* handleGetSentGifts({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    let response;
    try {
        response = yield call(authenticatedAxios.get,
            `${window.api_url}/site-secure/account/${payload.accountId}/gifts/sent/minimum`
        );
    } catch (error) {
        yield put(getSentGifts(error, {}, true));
    }
    yield put(getSentGifts({gifts: response.data}, {'sent': true}));
}
export function* watchGetSentGifts() {
    yield takeLatest(GET_SENT_GIFTS, handleGetSentGifts);
}


function* handleGetOrder({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    let response;
    try {
        response = yield call(authenticatedAxios.get,
            `${window.api_url}/orders/${payload.orderId}`
        );

    } catch (error) {
        yield put(getOrder(error, {}, true));
    }
    yield put(getOrder({
        order: response.data
    }, {'sent': true}));
}
export function* watchGetOrder() {
    yield takeLatest(GET_ORDER, handleGetOrder);
}


function* handleExchangeGiftMerchant({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    let response;
    try {
        const params = new URLSearchParams();
        params.append('merchant', payload.merchantId);
        response = yield call(authenticatedAxios.post, payload.link, params);

    } catch (error) {
        yield put(exchangeGiftMerchant(error, {}, true));
    }

    yield put(exchangeGiftMerchant({
        gift: response.data,
        exchangedGift: payload.exchangingGift
    }, {'sent': true}));
}
export function* watchExchangeGiftMerchant() {
    yield takeLatest(EXCHANGE_GIFT_MERCHANT, handleExchangeGiftMerchant);
}


function* handleExchangeGiftVirtualVisa({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    let response;
    try {
        const params = new URLSearchParams();
        params.append('email', payload.email);
        response = yield call(authenticatedAxios.post, payload.link, params);

    } catch (error) {
        yield put(exchangeGiftVirtualVisa(error, {}, true));
    }

    yield put(exchangeGiftVirtualVisa({
        virtualVisaGift: response.data
    }, {'sent': true}));
}
export function* watchExchangeGiftVirtualVisa() {
    yield takeLatest(EXCHANGE_GIFT_VIRTUAL_VISA, handleExchangeGiftVirtualVisa);
}


function* handleExchangeGiftPhysicalVisa({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }
    let response;
    try {
        response = yield call(authenticatedAxios.post, payload.link, {
            email: payload.email,
            first_name: payload.first_name,
            last_name: payload.last_name,
            address: {
                address_line1: payload.address_1,
                address_line2: payload.address_2,
                locality: payload.city,
                region: payload.state,
                postal_code: payload.zip,
                country: "US"
            }
        });

    } catch (error) {
        yield put(exchangeGiftPhysicalVisa(error, {}, true));
    }

    yield put(exchangeGiftPhysicalVisa({
        physicalVisaGift: response.data
    }, {'sent': true}));
}
export function* watchExchangeGiftPhysicalVisa() {
    yield takeLatest(EXCHANGE_GIFT_PHYSICAL_VISA, handleExchangeGiftPhysicalVisa);
}



function* handleSendThankYa({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const params = new URLSearchParams();
        params.append('message', payload.message);
        yield call(authenticatedAxios.post,
            `${window.api_url}/site-secure/thank-ya/send/${payload.visibleId}`,
            params);

    } catch (error) {
        yield put(sendThankYa(error, {}, true));
    }

    yield put(sendThankYa({
        sendThankYaSuccess: true
    }, {'sent': true}));
}
export function* watchSendThankYa() {
    yield takeLatest(SEND_THANKYA, handleSendThankYa);
}

function* handleCreatePaymentMethodWithRedemptionAccount({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        yield call(authenticatedAxios.post,
            `${window.api_url}/site-secure/payment-methods/create-with-redemption-method`,
            payload
        );
    } catch (error) {
        yield put(createPaymentMethodWithRedemptionAccount(error, {}, true));
    }

    yield put(createPaymentMethodWithRedemptionAccount({
        paymentMethodCreatedWithRedemptionMethodSuccess: true
    }, {'sent': true}));
}
export function* watchCreatePaymentMethodWithRedemptionAccount() {
    yield takeLatest(CREATE_PAYMENT_METHOD_WITH_REDEMPTION_ACCOUNT, handleCreatePaymentMethodWithRedemptionAccount);
}
